module.exports = __webpack_public_path__ + "img/si1a.6cb16398.png";